import React from "react";

const DeleteIcon = ({ cls = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={cls}
    >
      <path
        d="M20.65 5.33333H18.015C17.8177 4.39284 17.2957 3.54779 16.5371 2.9406C15.7784 2.33341 14.8294 2.00121 13.85 2L12.15 2C11.1706 2.00121 10.2216 2.33341 9.46294 2.9406C8.70425 3.54779 8.18228 4.39284 7.985 5.33333H5.35C5.12457 5.33333 4.90837 5.42113 4.74896 5.57741C4.58955 5.73369 4.5 5.94565 4.5 6.16667C4.5 6.38768 4.58955 6.59964 4.74896 6.75592C4.90837 6.9122 5.12457 7 5.35 7H6.2V17.8333C6.20135 18.938 6.64955 19.997 7.44629 20.7782C8.24302 21.5593 9.32324 21.9987 10.45 22H15.55C16.6768 21.9987 17.757 21.5593 18.5537 20.7782C19.3505 19.997 19.7987 18.938 19.8 17.8333V7H20.65C20.8754 7 21.0916 6.9122 21.251 6.75592C21.4104 6.59964 21.5 6.38768 21.5 6.16667C21.5 5.94565 21.4104 5.73369 21.251 5.57741C21.0916 5.42113 20.8754 5.33333 20.65 5.33333ZM12.15 3.66667H13.85C14.3772 3.6673 14.8914 3.82781 15.3219 4.1262C15.7524 4.42459 16.0782 4.84624 16.2547 5.33333H9.74535C9.9218 4.84624 10.2476 4.42459 10.6781 4.1262C11.1086 3.82781 11.6228 3.6673 12.15 3.66667ZM18.1 17.8333C18.1 18.4964 17.8313 19.1323 17.3531 19.6011C16.8749 20.0699 16.2263 20.3333 15.55 20.3333H10.45C9.7737 20.3333 9.1251 20.0699 8.64688 19.6011C8.16866 19.1323 7.9 18.4964 7.9 17.8333V7H18.1V17.8333Z"
        fill="currentColor"
      />
      <path
        d="M10.5 18C10.7652 18 11.0196 17.8946 11.2071 17.7071C11.3946 17.5196 11.5 17.2652 11.5 17V11C11.5 10.7348 11.3946 10.4804 11.2071 10.2929C11.0196 10.1054 10.7652 10 10.5 10C10.2348 10 9.98043 10.1054 9.79289 10.2929C9.60536 10.4804 9.5 10.7348 9.5 11V17C9.5 17.2652 9.60536 17.5196 9.79289 17.7071C9.98043 17.8946 10.2348 18 10.5 18Z"
        fill="currentColor"
      />
      <path
        d="M14.5 18C14.7652 18 15.0196 17.8946 15.2071 17.7071C15.3946 17.5196 15.5 17.2652 15.5 17V11C15.5 10.7348 15.3946 10.4804 15.2071 10.2929C15.0196 10.1054 14.7652 10 14.5 10C14.2348 10 13.9804 10.1054 13.7929 10.2929C13.6054 10.4804 13.5 10.7348 13.5 11V17C13.5 17.2652 13.6054 17.5196 13.7929 17.7071C13.9804 17.8946 14.2348 18 14.5 18Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DeleteIcon;
